import { FormItemProps } from 'antd'

import { Permissions } from 'src/api/requests'

export const requiredRules: FormItemProps['rules'] = [{ required: true }]

/** Whoever may validate a laboratory result also sends it to the doctor. There
 *  is no dedicated "validate result" permission yet, so rejecting a test — the
 *  validator's other action, and the only one the backend actually gates —
 *  stands in for it next to the approve permission. Add the real permission here
 *  once the backend exposes it. */
export const VALIDATE_RESULT_PERMISSIONS = [
  Permissions.INVESTIGATIONS_SPECIMENS_APPROVE,
  Permissions.INVESTIGATIONS_TESTS_REJECT
]

export const IDNP_REGEX = /^\d{13}$/

export const DEFAULT_PER_PAGE = 10
export const DEFAULT_ONE_HUNDRED_PER_PAGE = 100

export const ACCESS_TOKEN_KEY = 'access_token'
export const REFRESH_TOKEN_KEY = 'refresh_token'
export const USER_ID_KEY = 'user_id'
export const RESET_EMAIL = 'reset_email'

export const USER_ROLE_KEY = 'Sime-Role-Id'
export const USER_INSTITUTION_KEY = 'Sime-LegalEntity-Id'

export const ONE_SECOND_IN_MS = 1000
export const ONE_MINUTE = 60
export const ONE_MINUTE_IN_MS = 60 * ONE_SECOND_IN_MS
export const LEGAL_AGE = 18

export const LANGUAGE_KEYS = ['ro', 'ru']

export const FILE_MAX_SIZE = 5 * 1024 * 1024 // 5 MB

export const ACCEPTED_FILE_TYPES = [
  'application/pdf',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
]

export const PHONE_REGEX = /^(\+373|0)\s?(\d\s?)+$/
